import React from "react";
import { Box, Typography, Button } from "@mui/material";

export default function SectionHeader({ title, actionText, onAction }) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
            }}
        >
            <Typography
                sx={{
                    fontSize: 20,
                    fontWeight: 700,
                    color: "#111827",
                }}
            >
                {title}
            </Typography>

            {actionText && (
                <Button
                    size="small"
                    onClick={onAction}
                    sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        color: "#2563EB",
                    }}
                >
                    {actionText}
                </Button>
            )}
        </Box>
    );
}
